module.exports = "<svg class=\"ic-svg\">\r\n  <use attr.xlink:href=\"assets/images/symbol-defs.svg#{{icon}}\"></use>\r\n</svg>\r\n"